import React from 'react';
import { Title, Text, Link, Space } from 'components';
import { SUPPORT_EMAIL } from 'utils/constants';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';

const ThirdPartyCookieMessage = () => {
  const { md } = useBreakpoint();
  return (
    <Container $md={md}>
      <Title level={3}>Dashboard Access</Title>
      <Space direction="vertical">
        <Text>
          To access this dashboard, ensure that your browser allows third-party
          cookies. Visit your browser settings to enable them and then refresh
          the page. For optimal performance, we recommend using Google Chrome.
        </Text>
        <Text>
          If you encouter any further difficulties, feel free to contact our
          support team at{' '}
          <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}.</Link>
        </Text>
      </Space>
    </Container>
  );
};

export default ThirdPartyCookieMessage;

const Container = styled.div<{ $md: boolean }>`
  padding: ${({ $md }) => ($md ? '20%' : '10%')};
`;
